<template>
  <div class="container">
    <text-input
      v-money="value ? money : null"
      :hint="hint"
      :label="label"
      pattern="[0-9]*"
      inputmode="numeric"
      @input="onInput"
      @click="$emit('click')"
      :value="value"
      :required="required"
      :subhint="subhint"
      :validationError="validationError"
    />
  </div>
</template>

<script>
import { VMoney } from "v-money";
import TextInput from "@/components/core/TextInput";

export default {
  name: "MoneyField",
  components: { TextInput },
  directives: {
    money: VMoney
  },
  props: {
    value: String,
    label: String,
    hint: String,
    required: Boolean,
    subhint: String
  },
  data() {
    return {
      validationError: null,
      checked: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "$ ",
        suffix: "",
        precision: 0,
        masked: false
      }
    };
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
      if (this.checked) {
        this.isValid(val);
      }
    },

    checkValid() {
      this.checked = true;
      return this.isValid();
    },

    isValid(val) {
      // Por problema de sincronía con v-bind, paso el valor
      // por parámetro en onInput
      let value = val ? val : this.value;

      /* Sobreescribir método de validación */
      if (parseInt(value.replace(/\D/g, "")) <= 0) {
        this.validationError = "Debe ingresar un valor válido";
        return false;
      }

      // Cuit válido
      this.validationError = null;
      return true;
    }
  }
};
</script>

<style scoped></style>
